// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b4d11201","135":"38e7637f","141":"57097ba4","342":"cb7556df","528":"7d943975","722":"356100b4","859":"d258d762","953":"a77cff37"}[chunkId] + ".chunk.js";
};